import { PrimaryButton } from "components/Button/style";
import { DropdownSelect } from "components/DropdownSelect";
import { ModalCustom } from "components/ModalCustom";
import { Required } from "components/Required";
import { useState } from "react";
import { Form } from "react-bootstrap";
import {
  OPCOES_FORNECEDOR,
  OPCOES_PRENSA,
} from "../../constants/opcoesSolicitarAutorizacao";
import { IDadosSolicitarAutorizacao } from "../../interfaces/ILoteCriado";
import { CaixaCampos, ContainerBotoes, TextoDescricao } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirmar: (dados: IDadosSolicitarAutorizacao) => Promise<boolean>;
  carregando: boolean;
}

export function SolicitarAutorizacaoModal({
  show,
  handleClose,
  onConfirmar,
  carregando,
}: IProps) {
  const [fornecedor, setFornecedor] = useState("");
  const [prensa, setPrensa] = useState("");

  function fechar() {
    setFornecedor("");
    setPrensa("");
    handleClose();
  }

  async function confirmar() {
    const criado = await onConfirmar({ fornecedor, prensa: Number(prensa) });
    if (criado) {
      fechar();
    }
  }

  const fecharSeLivre = carregando ? () => {} : fechar;

  return (
    <ModalCustom
      show={show}
      handleClose={fecharSeLivre}
      title="Solicitar autorização"
      centered
      footer
      footerTools={
        <ContainerBotoes>
          <PrimaryButton
            type="button"
            outline
            variante="primary"
            onClick={fecharSeLivre}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            type="button"
            onClick={confirmar}
            disabled={!fornecedor || !prensa || carregando}
          >
            Solicitar
          </PrimaryButton>
        </ContainerBotoes>
      }
    >
      <TextoDescricao>
        Preencha as informações abaixo para solicitar autorização.
      </TextoDescricao>
      <CaixaCampos>
        <Form.Group>
          <Form.Label>
            Fornecedor <Required />
          </Form.Label>
          <DropdownSelect
            options={OPCOES_FORNECEDOR}
            selectedValue={fornecedor}
            onSelect={setFornecedor}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>
            Prensa <Required />
          </Form.Label>
          <DropdownSelect
            options={OPCOES_PRENSA}
            selectedValue={prensa}
            onSelect={setPrensa}
            required
          />
        </Form.Group>
      </CaixaCampos>
    </ModalCustom>
  );
}
